// app/session/session.js

(function () {
    'use strict';
    var controllerId = 'session'; 
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', 'common', '$q', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', '$translate', 'amMoment', 'moment', 'tmhDynamicLocale', session]);

    function session($rootScope, $scope, common, $q, bDialog, $routeParams, $uibModal, datacontext, sectionMenu, filterFilter, $translate, amMoment, moment, tmhDynamicLocale) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard

        var vm = this;
        vm.title = 'Sessioni';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);			

        vm.objName = "session"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.tests = [];
        vm.classi = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.addDisabled = !$rootScope.licenzaValida;
        vm.exportDisabled = false;
        vm.addTitle = $translate.instant('NuovaSessione'); 
        vm.bAddState = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.selTab = 0;
       // $scope.cont.recordForm.$setPristine();

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Data Decrescente', 'Data Crescente', 'Test'];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };

        //Elenchi dettaglio
        vm.list.allievi = [];
        vm.getRecord = getRecord;
        vm.getListAllievi = getListAllievi;
        vm.getSchedaCompetenze = getSchedaCompetenze;

        //Filtro
        vm.filter = {};        
        vm.fBStato = 0;
        vm.filter.stato = 0;
        vm.fTestId = 0;
        vm.filter.testId = 0;
        vm.fClasseId = 0;
        vm.filter.classeId = 0;
        vm.fAllievi = {};

        //filter per Anno: default l'anno corrente o per anno impostato gi� in altre aree
        if ($rootScope.annoScolastico == 0)
            vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        else
            vm.fAnno = $rootScope.annoScolastico;
        vm.filter.anno = vm.fAnno;

        //Elenchi per filtri e finestra modale di Create
        vm.test = [];
        vm.showResultsClick = showResultsClick;
        vm.showStatisticsClick = showStatisticsClick;
        vm.showPerformanceClick = showPerformanceClick;
        vm.showReviewClick = showReviewClick;
        vm.expiresChange = expiresChange;
        vm.tModeChanged = tModeChanged;
        vm.classeIdChanged = classeIdChanged;
        vm.annoChanged = function () {
            vm.classi = getListClassi();
            cerca();
        };
        vm.aggiornaVotiDidattica = aggiornaVotiDidattica;
        vm.calcolaStatistiche = calcolaStatistiche;

    	//datapicker
        vm.open = function ($event) {
        	$event.preventDefault();
        	$event.stopPropagation();

        	vm.opened = !vm.opened;
        };

        vm.dateOptions = {
        	formatYear: 'yy',
        	startingDay: 1
        };

        vm.currentLanguage = $translate.proposedLanguage() || $translate.use();
        amMoment.changeLocale(vm.currentLanguage);
        tmhDynamicLocale.set(vm.currentLanguage);
        
        if (vm.currentLanguage == "en") {
            vm.data = 'MM/dd/yyyy HH:mm';
        } else if (vm.currentLanguage == "it") {
            vm.data = 'dd/MM/yyyy HH:mm';
        }

        vm.format = 'dd/MM/yyyy';

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;

        vm.addAllievo = addAllievo;
        vm.deleteAllievo = deleteAllievo;

        vm.selectTest = selectTest;

        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.updateDocumenti = updateDocumenti;
        vm.activateSession = activateSession;
        vm.inactivateSession = inactivateSession;
        vm.finalActivateSession = finalActivateSession;
        vm.monitora = monitora;
        vm.delete = deleteItem;
        vm.votoEdit = votoEdit;
        vm.pdpEdit = pdpEdit;
        vm.stampaTest = stampaTest;

        //modale dettaglio abilit� e conoscenze
        vm.modalDetailAC = modalDetailAC;

        //Metodi download documenti
        vm.getRisultatiAlfabetico = getRisultatiAlfabetico;
        vm.getRisultatiPunteggio = getRisultatiPunteggio;
        vm.getRisultatiPerStudente = getRisultatiPerStudente;
        vm.getRiepilogo = getRiepilogo;
        vm.getRiepilogoTest = getRiepilogoTest;
        vm.getRisultatiDC = getRisultatiDC;

        vm.testCount = 0;

        // ---- ACTIVATE -------
        activate();

        function activate() {
        	var promises = [getListTest(), getListClassi()];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.sessionId != null) {
                            setView('detail');
                            getRecord($routeParams.sessionId, 0);
                        }
                        if ($routeParams.testId != null) {        //Crea sessione da test
                            setView('detail');
                            getRecord(0, 0);
                            vm.record.testId = $routeParams.testId;
                            datacontext.test_get($routeParams.testId).then(function (data) {
                                vm.record.testTitle = data.title;
                                vm.testCount = data.questionsCount;
                                vm.record.questionsCount = data.questionsCount;                                
                            });                            
                        }
                    });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.bStato = vm.fBStato == null ? 0 : vm.fBStato;            
            vm.filter.testId = vm.fTestId == null ? 0 : vm.fTestId;
            vm.filter.classeId = vm.fClasseId == null ? 0 : vm.fClasseId;
            vm.filter.anno = vm.fAnno == null ? -1 : vm.fAnno;
            if (vm.filter.anno != $rootScope.annoScolastico)
                $rootScope.annoScolastico = vm.filter.anno;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.session_countByProc(vm.filter.anno, vm.filter.bStato, vm.filter.testId, vm.filter.classeId)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.session_getAllByProc(vm.pageSize, vm.page, vm.filter.anno, vm.filter.bStato, vm.filter.testId, vm.filter.classeId, vm.ordine.value)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {        	
        	if (id == 0) //Su nuovo record
            {
        		vm.bAddState = true;
        		vm.index = -1;
        		vm.record = {};
        		//Parametri di default
        		vm.record.tModeId = 1;//Modalit� di valutazione
        		tModeChanged(vm.record.tModeId);
        		vm.record.expires = 0; //Modalit� senza limiti di tempo
        		vm.minDate = new Date();
						/*
        		vm.record.dtOnlyExpected = new Date().setHours(0, 0, 0, 0); //Modalit� senza limiti di tempo
        		vm.record.dtExpected = vm.record.dtOnlyExpected;
        		vm.record.HHExpected = 9;
        		vm.record.MinExpected = 0;
						*/

                vm.record.showResults = true;
                vm.record.showStatistics = true;
                vm.record.showPerformance = true;
                vm.record.showReview = true;
                vm.record.showSessions = true;

        	    //Azzera liste        		
        		vm.list.allievi = [];        		
                                
        		setView('detail');
        		return;
        	}
        	return datacontext.session_get(id).then(function (data) {        	    
        		vm.bAddState = false;
                vm.index = index;
                vm.record = data;                
                
                datacontext.risorsa_get(vm.record.docenteId).then(function (docente) {                    
                    if (docente.DidatticaCompetenze)
                        vm.didattica = true;
                    else
                        vm.didattica = false;
                });
                    
                
                if (vm.record.enabled || vm.record.performed)
            	    vm.minDate = null;
				else
            	    vm.minDate = new Date();

                if ((vm.record.dtOnlyExpected) != null) vm.record.dtOnlyExpected = new Date(vm.record.dtOnlyExpected);

                //Azzera liste
                vm.list.allievi = [];                
                datacontext.test_get(vm.record.testId).then(function (data) {
                    vm.testCount = data.questionsCount;
                });
                setView('detail');                
          });
        }        

        function addRecord(id) {
            return datacontext.session_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
                if (vm.record.enabled || vm.record.performed)
                	vm.minDate = null;
                else
                	vm.minDate = new Date();
            });
        }

        function updateItem(isValid) {
        	if (isValid) {
        		if (vm.record.expires == 1)
        			vm.record.expires = true;
        		else
        			vm.record.expires = false;
                                
        		if (vm.record.Id == null || vm.record.Id == 0) {
        			return datacontext.session_add(vm.record).then(function (data) {
                        vm.record.Id = data.Id;
                        vm.record.votoMax = data.votoMax;
                        vm.classeIdChanged();
                        addRecord(data.Id);
                        //getSchedaCompetenzeTest();
        				logSuccess($translate.instant('DatoSalvato'));
        			});
                } else {
        		    return datacontext.session_update(vm.record).then(function (data) {
        				vm.record.Id = data.Id;
        				vm.records[vm.index] = vm.record;
        				//getSchedaCompetenzeTest();
        				logSuccess($translate.instant('DatoSalvato'));
        			});
        		}
        	}
        }

        function updateDocumenti() {
            return datacontext.session_update(vm.record).then(function (data) {
                vm.record.Id = data.Id;
                vm.records[vm.index] = vm.record;

                if (vm.selTab == 1)
                    vm.getListAllievi(vm.record.Id);
                else if (vm.selTab == 2)
                    vm.getSchedaCompetenze();

                logSuccess($translate.instant('DatoSalvato'));
            });
        }

        function activateSession() {
            if (vm.loading == true) return;
            vm.loading = true;
        	return datacontext.session_activate(vm.record.Id).then(function (data) {
        		if (typeof (data) == 'undefined' || Number.isInteger(data))
                    return logError($translate.instant('ErroreElaborazione'));
                
                vm.record = data;
                vm.records[vm.index] = vm.record;
        		vm.minDate = null;
        		vm.list.allievi = getListAllievi();
        		vm.loading = false;

        		datacontext.risorsa_get(vm.record.docenteId).then(function (docente) {
        		    if (docente.DidatticaCompetenze)
        		        vm.didattica = true;
        		    else
        		        vm.didattica = false;
        		});

        		logSuccess($translate.instant('SessioneDisponibile'));
        	});
        }

        function inactivateSession() {
            if (vm.loading == true) return;
            vm.loading = true;

        	return datacontext.session_inactivate(vm.record.Id).then(function (data) {
        		if (typeof (data) == 'undefined' || Number.isInteger(data))
        		    return logError($translate.instant('ErroreElaborazione'));


                vm.record = data;
                vm.records[vm.index] = vm.record;
        		vm.minDate = new Date();
        		vm.list.allievi = [];
        		vm.loading = false;
        		logSuccess($translate.instant('SessioneNonDisponibile'));
        	});
        }

        function finalActivateSession() {
            if (vm.loading == true) return;
            vm.loading = true;

            return datacontext.session_enable(vm.record).then(function (data) {
                if (typeof (data) == 'undefined')
                    return logError($translate.instant('ErroreElaborazione'));

                if (data.codeRequired == true) {
                    datacontext.session_createCode(vm.record.Id).then(function (data) {

                        if (typeof (data) == 'undefined')
                            return logError($translate.instant('ErroreElaborazione'));

                        //if (vm.loading == true) return;

                        vm.loading = false;
                        logSuccess($translate.instant('SessioneAttiva'));
                        getRecord(vm.record.Id);
                        monitora();
                    });
                }
                else {
                    vm.loading = false;
                    logSuccess($translate.instant('SessioneAttiva'));
                    getRecord(vm.record.Id);
                    monitora();
                }
                
            });

        }
        
        function deleteItem(item) {
            var msg = ' ' + $translate.instant('Sessione') + ' '+ '"' + item.testTitle + '"';
        	bDialog.deleteDialog(msg).then(function () {
        		return datacontext.session_delete(item.Id).then(function (data) {
        		    if (data != "204") return logError($translate.instant('ErroreRimozione'));

                    var index = vm.records.indexOf(item);
        			vm.records.splice(index, 1);
        			vm.countRecords--;
        		});
        	});
        }

        function tModeChanged(iMode) {
        	if(iMode == 1)
        		vm.record.codeRequired = true;
        	else 
        		vm.record.codeRequired = false;
        }

        function classeIdChanged() {
        	if (vm.record.classeId > 0)
        		vm.record.groupName = $("#classeId option:selected").text();
					else
        		vm.record.groupName = '';
        }

        function salvaSchedaCompetenzeSession(item) {
            return datacontext.schedaCompetenzeSession_update(item).then(function (data) {
                if (data) {
                    logSuccess($translate.instant('DatiSalvati'));
                }
                else
                    logError($translate.instant('ErroreModifica'));
            });
            
        }

        function getSchedaCompetenze() {
            datacontext.studenteSession_getAllByProc(0, 0, vm.record.Id, '', 'studente').then(function (data) {
                vm.list.allievi = data;

                if (vm.list.allievi.length == 0)
                    return [];

                datacontext.schedaCompetenzeSession_getAll(vm.record.Id, vm.record.docenteId).then(function (schedaDidattica) {
                    vm.schedaDidattica = schedaDidattica;                    
                    vm.list.allievi.forEach(function (allievo) {
                        allievo.schedaDidattica = [];
                        if (allievo.present) {
                            var sc = _.filter(schedaDidattica, function (o) { return o.StudenteSessionId == allievo.Id; });
                            if (sc && sc.length > 0)
                                allievo.schedaDidattica = sc;                            
                        }
                    });
                });
            });
        }

        function aggiornaVotiDidattica() {
            var msg = "";
            msg = $translate.instant('AvvisoRicalcoloDidattica') + "?";

            bDialog.confirmationDialog($translate.instant('Conferma'), msg).then(function () {
                return datacontext.session_aggiornaVotiDidattica(vm.record.Id).then(function (data) {
                    if (!data) {
                        getSchedaCompetenze();
                        logSuccess($translate.instant('DatoSalvato'));
                    }
                    else {
                        logError($translate.instant('ErroreElaborazione'));
                    }
                });
            });
        }

        function calcolaStatistiche() {
            var msg = "";
            msg = $translate.instant('AvvisoRicalcolaRisultati') + "?";

            bDialog.confirmationDialog($translate.instant('Conferma'), msg).then(function () {
                return datacontext.session_calcolaStatistiche(vm.record.Id).then(function (data) {
                    if (!data) {
                        getListAllievi();
                        logSuccess($translate.instant('DatoSalvato'));
                    }
                    else {
                        logError($translate.instant('ErroreElaborazione'));
                    }
                });
            });
        }

        //Elenchi Parametri
        function getListAllievi() {            
            return datacontext.studenteSession_getAllByProc(0, 0, vm.record.Id, '', 'studente').then(function (data) {                                      
                return vm.list.allievi = data;
        	});
        }

        function getListTest() {
        	return datacontext.test_getAllList().then(function (data) {
                return vm.tests = data;
            });
        }

        function getListClassi() {
            var anno = vm.fAnno == null ? -1 : vm.fAnno;

        	return datacontext.classe_getAllList(anno).then(function (data) {
        		return vm.classi = data;
        	});
        }

    	//Metodi di delete object List
        function deleteAllievo(item) {
            var msg = ' l\'' + $translate.instant('allievo') + ' '+ item.studente;
        	bDialog.deleteDialog(msg).then(function () {
        		return datacontext.studenteSession_delete(item.Id).then(function (data) {
        		    if (data != "204") return logError($translate.instant('ErroreRimozione'));

                    var index = vm.list.allievi.indexOf(item);
                    vm.list.allievi.splice(index, 1);
                    vm.record.stat_numAllievi = vm.record.stat_numAllieviPresenti = vm.list.allievi.length;
                    vm.records[vm.index] = vm.record;
        		});
        	});
        }

        //Metodi interfaccia FIltri
        function setfTest() {
            if (vm.checkfIncarico == false) {
                vm.fTest.ProfiloId = '';
                vm.fTest.Risorsa = '';
            }
        }

        function showResultsClick()
        {
        	if (!vm.record.showResults)
        	{
        		vm.record.showStatistics = false;
        		vm.record.showPerformance = false;
        		vm.record.showReview = false;
        	}
        	
        	return false;
        }

        function showStatisticsClick() {
        	if (!vm.record.showResults)
        		vm.record.showStatistics = false;
        	return false;
        }

        function showPerformanceClick() {
        	if (!vm.record.showResults) 
        		vm.record.showPerformance = false;
        	return false;
        }

        function showReviewClick() {
        	if (!vm.record.showResults) 
        		vm.record.showReview = false;
        	return false;
        }

        function expiresChange() {
        	if (vm.record.expires == 0)
        		vm.record.minutesToExpire = 0;
        	return false;
        }

    	//Metodi interfaccia FIltri
        function setfAllievi() {
        	if (vm.checkfAllievo == false) {
        		vm.fAllievi.Studente = '';
        	}
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
            getListClassi();
        	setView('detail');
        	getRecord(0, 0);
        };

    	// Incarico
        function addAllievo() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/EDUP_Session/modal/studenteSessionAdd.html?version=43',
                controller: 'studenteSessionAdd',
                resolve: {
            			sessionId: function () {
            				return vm.record.Id;    //sessionId impostata con record visualizzato
            			},
                  classi: function () {
                      return null;   //Carica Array con la sola session visualizzata 
                  },
                  classeId: function () {
                  	return vm.record.classeId;    //classeId impostata con record visualizzato
                  }
              }
          });

          modalInstance.result.then(function (returnItem) {
          	//logSuccess("Record salvato con successo");
              vm.getListAllievi(vm.record.Id).then(function (o) {
                  vm.record.stat_numAllievi = vm.record.stat_numAllieviPresenti = vm.list.allievi.length;
                  vm.records[vm.index] = vm.record;
              });                            
          });
        }

        // Seleziona test
        function selectTest() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/EDUP_Session/modal/testSelect.html?version=43',
                controller: 'testSelect',
                windowClass: 'modal-wide',
                resolve: {                    
                }
            });

            modalInstance.result.then(function (returnItem) {
                vm.record.testId = returnItem.id;
                vm.record.testTitle = returnItem.title;
                vm.record.questionsCount = returnItem.questionsCount;
                vm.testCount = returnItem.questionsCount;                
            });
        }

        //modale visualizzazione dettaglio competenze
        function modalDetailAC(item, allievo) {            
            var modalDetail = {};
            var readonly = false;
            angular.copy(item, modalDetail);            
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/EDUP_Session/modal/schedaCompetenzeSessionDetail.html?version=43',
                controller: 'schedaCompetenzeSessionDetail',
                windowClass: 'modal-wide',
                resolve: {                      // in resolve si indicano, separati da virgola, gli oggetti che vuoi passare alla modale
                    schedaCompetenzeSessionDetail: function () {
                        return modalDetail;
                    },
                    allievo: function () {
                        return allievo;
                    },
                    readonly: function () {
                        return readonly;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                salvaSchedaCompetenzeSession(returnItem);
                getSchedaCompetenze();
            });
        }				
        
        //Modifica voto
        function votoEdit(index, studenteSession) {            
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/EDUP_Session/modal/votoEdit.html?version=43',
                controller: 'votoEdit',
                resolve: {
                    studenteSession: function () {
                        return studenteSession;
                    },
                    votoMax: function () {
                        return vm.record.votoMax;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                getListAllievi();
                logSuccess($translate.instant('DatoSalvato'));
            });
        }

        //Modifica PDP
        function pdpEdit(index, studenteSessionPdp) {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/EDUP_Session/modal/pdpEdit.html?version=43',
                controller: 'pdpEdit',
                resolve: {
                    studenteSessionPdp: function () {
                        return studenteSessionPdp;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //vm.list.allievi[index] = returnItem;
                getListAllievi();
                logSuccess($translate.instant('DatoSalvato'));
                //aggiornaSession();
            });
        }

        //Monitora
        // Seleziona test
        function monitora() {
            var allievi = getListAllievi(vm.record.Id);
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/EDUP_Session/modal/monitora.html?version=43',
                controller: 'monitora',                
                resolve: {
                    item: function () {
                        return vm.record;
                    },
                    allievi: function () {
                        return allievi;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == true)
                    getRecord(vm.record.Id).then(function (data) {
                        vm.list.allievi = getListAllievi();
                    });
            });
        }

        function stampaTest(testId) {
            if (!testId)
                testId = vm.record.Id;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/EDUP_Test/modal/stampaTest.html?version=43",
                controller: "stampaTest",
                windowClass: 'modal-wide-print',
                resolve: {
                    testId: function () {
                        return testId;
                    }
                }
            });
        }
				
        //****************************************************
        // Metodi download documenti
        //****************************************************

        function getRisultatiAlfabetico() {
            if (vm.spinRisultatiAlfabetico == true)
                return;

            vm.spinRisultatiAlfabetico = true;            
            var lingua = $translate.proposedLanguage() || $translate.use();            
            common.$http.get('/edup/report/GetRisultatiAlfabetico?lang=' + lingua + '&sessionId=' + vm.record.Id, { responseType: 'arraybuffer' })
                .then(function (response) {                    
                    var a = document.createElement("a");
                    a.setAttribute('style', 'display:none');

                    document.body.appendChild(a);

                    var file = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);

                    a.href = fileURL;                    

                    var pdfName = "_Risultati_alfabetico.pdf";
                    if (lingua == "en")
                        pdfName = "_Alphabetical_results.pdf";

                    if (common.detectIE())
                        window.navigator.msSaveBlob(file, vm.record.Id + pdfName);
                    else
                        a.download = vm.record.Id + pdfName;

                    a.click();
                    //window.URL.revokeObjectURL(fileURL);
                    document.body.removeChild(a);

                    vm.spinRisultatiAlfabetico = false;
                })
                .catch(function (message) {                    
                    vm.spinRisultatiAlfabetico = false;
                    logError($translate.instant('ImpossibileScaricare'));
                });
        }

        function getRisultatiPunteggio() {
            if (vm.spinRisultatiPunteggio == true)
                return;

            vm.spinRisultatiPunteggio = true;
            var lingua = $translate.proposedLanguage() || $translate.use();
            common.$http.get('/edup/report/getRisultatiPunteggio?lang=' + lingua + '&sessionId=' + vm.record.Id, { responseType: 'arraybuffer' })
                .then(function (response) {
                    var a = document.createElement("a");
                    a.setAttribute('style', 'display:none');

                    document.body.appendChild(a);

                    var file = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);

                    a.href = fileURL;

                    var pdfName = "_Risultati_punteggio.pdf";
                    if (lingua == "en")
                        pdfName = "_Score_results.pdf";

                    if (common.detectIE())
                        window.navigator.msSaveBlob(file, vm.record.Id + pdfName);
                    else
                        a.download = vm.record.Id + pdfName;
                    a.click();
                    //window.URL.revokeObjectURL(fileURL);
                    document.body.removeChild(a);

                    vm.spinRisultatiPunteggio = false;
                })
                .catch(function (message) {
                    vm.spinRisultatiPunteggio = false;
                    logError($translate.instant('ImpossibileScaricare'));
                });
        }

        function getRisultatiPerStudente() {
            if (vm.spinRisultatiPerStudente == true)
                return;

            vm.spinRisultatiPerStudente = true;
            var lingua = $translate.proposedLanguage() || $translate.use();
            common.$http.get('/edup/report/GetRisultatiPerStudente?lang=' + lingua + '&sessionId=' + vm.record.Id, { responseType: 'arraybuffer' })
                .then(function (response) {
                    var a = document.createElement("a");
                    a.setAttribute('style', 'display:none');                    
                    document.body.appendChild(a);

                    var file = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);

                    a.href = fileURL;

                    var pdfName = "_Risultati_studenti.pdf";
                    if (lingua == "en")
                        pdfName = "_Students_results.pdf";

                    if (common.detectIE())
                        window.navigator.msSaveBlob(file, vm.record.Id + pdfName);
                    else
                        a.download = vm.record.Id + pdfName;
                    a.click();                   
                    // window.URL.revokeObjectURL(fileURL);
                    document.body.removeChild(a);

                    vm.spinRisultatiPerStudente = false;
                })
                .catch(function (message) {
                    vm.spinRisultatiPerStudente = false;
                    logError($translate.instant('ImpossibileScaricare'));
                });
        }

        function getRiepilogo() {
            if (vm.spinRiepilogo == true)
                return;

            vm.spinRiepilogo = true;
            var lingua = $translate.proposedLanguage() || $translate.use();
            common.$http.get('/edup/report/GetRiepilogo?lang=' + lingua + '&sessionId=' + vm.record.Id, { responseType: 'arraybuffer' })
                .then(function (response) {
                    var a = document.createElement("a");
                    a.setAttribute('style', 'display:none');

                    document.body.appendChild(a);

                    var file = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);

                    a.href = fileURL;

                    var pdfName = "_Risultati_domande.pdf";
                    if (lingua == "en")
                        pdfName = "_Answers_summary.pdf";

                    if (common.detectIE())
                        window.navigator.msSaveBlob(file, vm.record.Id + pdfName);
                    else
                        a.download = vm.record.Id + pdfName;
                    a.click();
                    //window.URL.revokeObjectURL(fileURL);
                    document.body.removeChild(a);

                    vm.spinRiepilogo = false;
                })
                .catch(function (message) {
                    vm.spinRiepilogo = false;                    
                    logError($translate.instant('ImpossibileScaricare'));
                });
        }

        function getRiepilogoTest() {
            if (vm.spinRiepilogoTest == true)
                return;

            vm.spinRiepilogoTest = true;
            var lingua = $translate.proposedLanguage() || $translate.use();
            common.$http.get('/edup/report/GetRiepilogoTest?lang=' + lingua + '&sessionId=' + vm.record.Id, { responseType: 'arraybuffer' })
                .then(function (response) {
                    var a = document.createElement("a");                    
                    a.setAttribute('style', 'display:none');

                    document.body.appendChild(a);
                    
                    var file = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);                   

                    a.href = fileURL;

                    var pdfName = "_Griglia_esito.pdf";
                    if (lingua == "en")
                        pdfName = "_Test_summary.pdf";

                    if (common.detectIE())
                        window.navigator.msSaveBlob(file, vm.record.Id + pdfName);
                    else
                        a.download = vm.record.Id + pdfName;
                    a.click();
                    //window.URL.revokeObjectURL(fileURL);
                    document.body.removeChild(a);

                    vm.spinRiepilogoTest = false;
                })
                .catch(function (message) {
                    vm.spinRiepilogoTest = false;
                    logError($translate.instant('ImpossibileScaricare'));
                });
        }

        function getRisultatiDC() {
            if (vm.spinRisultatiDC == true)
                return;

            vm.spinRisultatiDC = true;
            var lingua = $translate.proposedLanguage() || $translate.use();
            common.$http.get('/edup/report/GetDCStudenti?lang=' + lingua + '&sessionId=' + vm.record.Id, { responseType: 'arraybuffer' })
                .then(function (response) {
                    var a = document.createElement("a");
                    a.setAttribute('style', 'display:none');

                    document.body.appendChild(a);

                    var file = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);

                    a.href = fileURL;

                    var pdfName = "_Risultati_Didattica.pdf";
                    if (lingua == "en")
                        pdfName = "_Skills_Didactic_Results.pdf";

                    if (common.detectIE())
                        window.navigator.msSaveBlob(file, vm.record.Id + pdfName);
                    else
                        a.download = vm.record.Id + pdfName;
                    a.click();
                    //window.URL.revokeObjectURL(fileURL);
                    document.body.removeChild(a);

                    vm.spinRisultatiDC = false;
                })
                .catch(function (message) {
                    vm.spinRisultatiDC = false;
                    logError($translate.instant('ImpossibileScaricare'));
                });
        }
    }
})();
